// The 18 shareable bino document kinds (conventions §15). This is the single
// source of truth used to constrain the search kind facet (R8) — the registry
// only ever stores one of these.
export const SHAREABLE_KINDS = [
  "LayoutPage",
  "LayoutCard",
  "Text",
  "Table",
  "ChartStructure",
  "ChartTime",
  "ChartScatter",
  "ChartBubble",
  "ChartBullet",
  "Tree",
  "Grid",
  "Asset",
  "ComponentStyle",
  "Internationalization",
  "ScalingGroup",
  "RuleSet",
  "DataSet",
  "DataSource",
] as const;

export type ShareableKind = (typeof SHAREABLE_KINDS)[number];

const KIND_SET = new Set<string>(SHAREABLE_KINDS);

/** isShareableKind reports whether k is one of the 18 shareable kinds. */
export function isShareableKind(k: string): k is ShareableKind {
  return KIND_SET.has(k);
}
